import { random, times } from 'lodash'

const SUFFIX_LENGTH = 6
const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

export function makeUniqueID(prefix: string): string {
  const suffix = times(SUFFIX_LENGTH, () => CHARS[random(CHARS.length - 1)]).join('')
  return `${prefix}_${suffix}`
}
